const relatorio_de_situacao_final_dos_alunos = [
  {
    path: "/relatorio-de-situacao-final-dos-alunos",
    name: "relatorio_de_situacao_final_dos_alunos",
    meta: {
      allowedPermissions: ["relatorio_final_alunos"],
      breadCrumb:
        "Processo de Resultado Final - Acompanhamento de Resultados Finais",
    },
    component: () =>
      import(
        "@/views/RelatorioDeSituacaoFinalDosAlunos/RelatorioDeSituacaoFinalDosAlunos.vue"
      ),
  },
];

export { relatorio_de_situacao_final_dos_alunos };
